import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="relative w-full px-6 md:px-10 py-20 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20residential%20lobby%20interior%20with%20marble%20floors%2C%20modern%20chandeliers%2C%20warm%20ambient%20lighting%2C%20elegant%20furniture%2C%20high%20ceilings%2C%20sophisticated%20atmosphere%2C%20golden%20and%20cream%20tones%2C%20refined%20minimalist%20aesthetic&width=1800&height=800&seq=cta-bg-2026&orientation=landscape"
          alt="精品八区尊享体验"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      <div className="relative z-10 max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-white mb-4">
          开启您的品质生活之旅
        </h2>
        <p className="text-sm md:text-base text-white/70 leading-relaxed mb-8">
          加入精品八区，与500+精英会员共享高端精选资源与优质生活体验。立即申请，专属顾问将为您提供一对一咨询服务。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/about"
            className="px-8 py-3 text-sm font-medium whitespace-nowrap cursor-pointer rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300"
          >
            立即申请入会
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 text-sm font-medium whitespace-nowrap cursor-pointer rounded-full border border-white/30 text-white hover:bg-white/10 transition-all duration-300"
          >
            预约参观体验
          </Link>
        </div>
      </div>
    </section>
  );
}